import React from 'react';
import Header from '../components/Header';

export default (props: any) => <Header {...props} />;
